// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTPERPlhiuHZSf091tJwh9cZaSZBaQWHM",
  authDomain: "medicoin-14754.firebaseapp.com",
  projectId: "medicoin-14754",
  storageBucket: "medicoin-14754.firebasestorage.app",
  messagingSenderId: "75413140751",
  appId: "1:75413140751:web:7068290da87432e26cba7a",
  measurementId: "G-H35CS3FTZN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Realtime Database
export const db = getDatabase(app, "https://medicoin-14754-default-rtdb.firebaseio.com");
export const auth = getAuth(app);
export { firebaseConfig };

export default app;
